/* jshint ignore:start */
import React, { Component } from "react";
import SearchBar from "./components/SearchBar";
import VideoList from "./components/VideoLists/VideoList";
import API from "./API/YTAPI";
import ErrorBanner from "./components/ErrorBanner";
import VideoDetail from "./components/VideoDetail/VideoDetail";
import ScrollToTop from "./components/ScrollTop/ScrollToTop";
const KEY = "AIzaSyCNbtnHsvonohzT04tYwxG0M24YUGqzEeg";

class App extends Component {
  state = {
    error: null,
    videoList: [],
    selectedVideo: null,
    loading: false,
    showScroll: false,
  };

  onVideoSelect = (video) => {
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
    this.setState({ selectedVideo: video, loading: false });
  };

  onScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  onSearchHandler = async (term) => {
    this.setState({ loading: true });
    if (!term) {
      this.setState({ error: term, loading: false, showScroll: false });
    } else {
      this.setState({ error: term });
      const response = await API.get("/search", {
        params: {
          part: "snippet",
          type: "video",
          maxResults: 10,
          key: `${KEY}`,
          q: term,
        },
      });
      console.log(response.data);
      this.setState({
        videoList: response.data.items,
        loading: false,
        showScroll: true,
      });
    }
  };
  render() {
    return (
      <div className="container-fluid">
        <div className="text-center" style={{ color: "white" }}>
          <h5>
            <b>V-CLIP</b>
          </h5>
        </div>
        <SearchBar onSearch={this.onSearchHandler} />
        <div className="row">
          {this.state.loading && (
            <div className="col-12 col-sm-6 col-md-8 col-xl-12 mt-2 text-center">
              <div className="d-flex justify-content-center">
                <div className="spinner-border text-light" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          )}
          {this.state.selectedVideo && (
            <div className="col-12 col-sm-6 col-md-8 mt-2">
              {this.state.error && (
                <VideoDetail videoDetail={this.state.selectedVideo} />
              )}
            </div>
          )}

          {this.state.selectedVideo === null ? (
            <div className="col-12 col-md-4 col-xl-12">
              {this.state.error && (
                <VideoList
                  selectVideo={this.onVideoSelect}
                  videos={this.state.videoList}
                />
              )}
            </div>
          ) : (
            <div className="col-12 col-md-4">
              {this.state.error && (
                <VideoList
                  selectVideo={this.onVideoSelect}
                  videos={this.state.videoList}
                />
              )}
            </div>
          )}
        </div>
        {this.state.error === "" && <ErrorBanner error={this.state.error} />}
        {this.state.videoList && this.state.showScroll && (
          <div onClick={this.onScrollToTop}>
            <ScrollToTop />
          </div>
        )}
      </div>

      // </div>
    );
  }
}

export default App;
